import React, { useEffect, useState } from "react";

const Paylink = () => {

    const [response, setResponse] = useState("");

    const merchantUserId = "test_tbVT_3d";
    const publicKey = "test";
    const dataKey = "test";

    const reference = "latpaydev";
    const amount = "0.10";
    const currency = "EUR";
    const description = "test_from_latpaydev";

    const firstname = "NA";
    const lastname = "NA";
    const email = "support@latpay.com";


    useEffect(() => {

        const jquery = document.createElement("script");
        jquery.src = "https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js";
        jquery.async = true;

        jquery.onload = () => {

            // console.log("jQuery Loaded");

            const latpay = document.createElement("script");
            latpay.src = "https://lateralpayments.com/checkout-staging/Scripts/Latpay3.js";
            latpay.async = true;

            latpay.onload = () => {

                // console.log("Latpay Script Loaded");

                window.LatpayCheckout.open_googlepay({
                    merchantuserid: merchantUserId,
                    publickey: publicKey,
                    currency: currency,
                    amount: amount,
                    reference: reference,
                    description: description,
                    status: function (status) {
                        // console.log("Latpay Status:", status);
                    }
                });

                window.LatpayCheckout.OnPaymentCompleted = function (val) {
                    // console.log("Payment Completed:", val);
                    setResponse(JSON.stringify(val, null, 2));
                };

            };

            document.body.appendChild(latpay);
        };

        document.body.appendChild(jquery);

    }, []);


    const generateSHA256 = async (data) => {

        const encoder = new TextEncoder();
        const msgUint8 = encoder.encode(data);

        const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);

        return Array.from(new Uint8Array(hashBuffer))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');

    };


    const generateTranskey3dSecure = async () => {

        const data = currency + amount + reference + "Y" + dataKey;

        return await generateSHA256(data);

    };


    const handlePayment = async () => {

        const transkey3dSecure = await generateTranskey3dSecure();

        // console.log("3D Secure Transkey:", transkey3dSecure);

        window.LatpayCheckout.secure3DPayment({
            amount: amount,
            currency: currency,
            reference: reference,
            description: description,
            firstname: firstname,
            lastname: lastname,
            email: email,
            transkey: transkey3dSecure,
            is3dcheck: 'Y'
        });

    };


    return (
        <div style={styles.page}>

            <div style={styles.checkoutCard}>

                <h2 style={styles.heading}>Checkout</h2>

                <div style={styles.orderBox}>

                    <h5>Order Summary</h5>

                    <div style={styles.productRow}>
                        <span>Wallet Test Product</span>
                        <span>€0.10</span>
                    </div>

                    <hr />

                    <div style={styles.totalRow}>
                        <span>Total</span>
                        <span>€0.10 EUR</span>
                    </div>

                </div>

                <div style={styles.paymentBox}>

                    <h5>Payment Details</h5>

                    <div id="latpay-element"></div>

                    {/* <button style={styles.checkoutBtn} onClick={handlePayment}>
                        Pay € 0.10
                    </button> */}

                </div>

                <div style={styles.responseBox}>
                    {/* <h3>Transaction Response</h3> */}
                    <pre>{response}</pre>
                </div>

            </div>

        </div>
    );
};


const styles = {

  page: {
    fontFamily: "Helvetica Neue, Arial",
    background: "#f5f7fa",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  checkoutCard: {
    width: "520px",
    background: "#ffffff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)"
  },

  heading: {
    textAlign: "center",
    marginBottom: "25px",
    fontSize: "25px"
  },

  orderBox: {
    background: "#fafafa",
    padding: "20px",
    borderRadius: "8px",
    marginBottom: "20px",
  },

  productRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px"
  },

  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "bold",
    fontSize: "18px",
    marginTop: "10px"
  },

  paymentBox: {
    marginTop: "20px"
  },

  checkoutBtn: {
    width: "100%",
    marginTop: "15px",
    padding: "12px",
    fontSize: "16px",
    backgroundColor: "#263471",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
  },

  responseBox: {
    marginTop: "25px",
    background: "#f1f1f1",
    padding: "15px",
    borderRadius: "6px",
    fontSize: "13px",
    textAlign: "left"
  }

};

export default Paylink;